/* 路由设置 */
import Vue from "vue";
import Router from "vue-router";
import store from "../store";

/* 动态载入路由模块 */
import Login from "../pages/login";
import Admin from "../pages/admin";

/* 动态载入产品目录路由 */
import { getProductsRoutes } from "./product";

Vue.use(Router);

let modules = [];
export const fronts = [];
export const backend = [];

const moduleFiles = require.context(".", true, /\.js$/);
moduleFiles.keys().forEach(key => {
    if (key !== "./index.js" && key !== "./config.js") {
        if (moduleFiles(key).default) {
            if (key !== "./front.js") {
                modules.push(...moduleFiles(key).default);
            } else {
                fronts.push(...moduleFiles(key).default);
            }
        }
    }
});
// 后台路由排序
modules.sort((a, b) => (a.sort || 100) - (b.sort || 100));

backend.push({
    name: "后台主页",
    path: "/",
    component: Admin,
    redirect: "/control",
    children: modules // 加载模块
});

const createRouter = () => {
    const routes = [
        {
            name: "登录系统",
            path: "/login",
            component: Login
        }
    ];
    const originalPush = Router.prototype.push;
    Router.prototype.push = function push(location) {
        return originalPush.call(this, location).catch(err => err);
    };
    const router = new Router({
        routes,
        mode: "history" // 移除地址栏里边的#号键
    });
    router.beforeEach((to, from, next) => {
        if (to.path.startsWith("/tools/")) {
            document.title = to.matched
                .map(it => it.meta.title)
                .filter(t => t)
                .reverse()
                .join(" - ");
        } else {
            document.title = to.matched
                .filter(it => it.name !== "后台主页" && it.path !== "")
                .map(it => it.name)
                .reverse()
                .join(" - ");
        }
        if (to.path === "/login") {
            next();
        } else if (to.name === "免责声明" || to.name === "知识产权声明") {
            next();
        } else {
            if (
                store.getters.token !== "" &&
                store.getters.token_refresh > Date.parse(new Date()) / 1000
            ) {
                if (store.getters.commonuser) {
                    //普通会员
                    if (to.matched[0].name === "后台主页") {
                        //普通会员要登录后台
                        next("/product-list");
                    } else {
                        next();
                    }
                } else {
                    next();
                }
            } else {
                next({
                    path: "/login",
                    query: { redirect: to.fullPath }
                });
            }
        }
    });
    router.addRoutes(getProductsRoutes());
    router.addRoutes(fronts);
    router.addRoutes(backend);
    return router;
};

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js